/** @jsx jsx */
import { css } from '@emotion/core';
import { Theme } from 'features/Theme';

const styles = {
  textField: (theme: Theme) => {
    // Stylings here are lifted from the Mui's OutlinedInput.
    const palette = theme.mui.palette;
    const borderColor =
      palette.type === 'light'
        ? 'rgba(0, 0, 0, 0.23)'
        : 'rgba(255, 255, 255, 0.23)';

    const disabledBackground =
      palette.type === 'light'
        ? 'rgba(0, 0, 0, 0.09)'
        : 'rgba(255, 255, 255, 0.09)';

    return css`
      & .MuiInputBase-root {
        border: 1px solid ${borderColor};
        border-radius: ${theme.mui.shape.borderRadius}px;
        background: none;
        &:hover {
          border-color: ${palette.text.primary};
          background: none;
        }
        &.Mui-focused {
          border-color: ${palette.primary.main};
          background: none;
        }
        &.Mui-error {
          border-color: ${palette.error.main};
          background: none;
        }
        &.Mui-disabled {
          background: ${disabledBackground};
          border-color: transparent;
          color: ${palette.text.primary};
        }
        .MuiInputBase-input::-webkit-input-placeholder {
          // Improve contrast with white background for better accessibility.
          opacity: 0.65;
        }
      }
    `;
  },
};

export default styles;
